export default __webpack_public_path__ + "static/TransitionalMobile-bfdad5d5256b38531bb54e4865873ede.png";